<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Voucher</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="input-container">
        <div class="row">
          <div class="col-12">
            <app-block-text
              [maxLength]="500"
              [type]="'link'"
              (handleOnChange)="onChange($event, 'VoucherImage')"
              [placeholder]="imgPlaceholder"
              [blockData]="block.variables?.VoucherImage ?? ''"
              variable="VoucherImage"
              [isImage]="true"
              [blockId]="block.blockId"
            ></app-block-text>
          </div>
          <div class="col-4">
            <app-block-text
              [maxLength]="500"
              [type]="'alt'"
              (handleOnChange)="onChange($event, 'VoucherAlt')"
              [blockData]="block.variables?.VoucherAlt ?? ''"
              [placeholder]="altPlaceholder"
              variable="VoucherAlt"
            ></app-block-text>
          </div>
          <div class="col-4">
            <app-block-text
              [type]="'content'"
              [maxLength]="500"
              (handleOnChange)="onChange($event, 'VoucherHeading')"
              [blockData]="block.variables?.VoucherHeading ?? ''"
              [placeholder]="headingPlaceholder"
              variable="VoucherHeading"
            ></app-block-text>
          </div>
          <div class="col-4">
            <app-block-text
              [type]="'content'"
              [maxLength]="500"
              (handleOnChange)="onChange($event, 'VoucherText')"
              [blockData]="block.variables?.VoucherText ?? ''"
              [placeholder]="textPlaceholder"
              variable="VoucherText"
            ></app-block-text>
          </div>

          <div class="col-4">
            <app-block-text
              [type]="'action-link'"
              [maxLength]="500"
              (handleOnChange)="onChange($event, 'VoucherLink')"
              [blockData]="block.variables?.VoucherLink ?? ''"
              [placeholder]="linkPlaceholder"
              (handleOnSegmentChange)="
                handleOnSegmentChange($event, 'VoucherLinkSegmentRegex')
              "
              [selectedSegment]="block.variables?.VoucherLinkSegmentRegex ?? ''"
              variable="VoucherLink"
            ></app-block-text>
          </div>
          <div class="col-4">
            <app-block-text
              [type]="'content'"
              [maxLength]="30"
              (handleOnChange)="onChange($event, 'VoucherCtaText')"
              [blockData]="block.variables?.VoucherCtaText ?? ''"
              [placeholder]="ctaTextPlaceholder"
              variable="VoucherCtaText"
              [maxLength]="30"
            ></app-block-text>
          </div>
          <div class="col-4">
            <app-block-text
              [maxLength]="4000"
              [type]="'content'"
              (handleOnChange)="onChange($event, 'VoucherParagraph')"
              [blockData]="block.variables?.VoucherParagraph ?? ''"
              [placeholder]="paragraphPlaceholder"
              variable="VoucherParagraph"
            ></app-block-text>
          </div>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row">
          <div class="col-4">
            <img
              *ngIf="block.variables?.VoucherImage"
              [src]="$safeNavigationMigration(block.variables?.VoucherImage)"
              class="img-fluid"
              [alt]="$safeNavigationMigration(block.variables?.VoucherAlt)"
              style="max-width: inherit !important"
            />
          </div>
          <div class="col-4 text-center">
            <div [innerHTML]="$safeNavigationMigration(block.variables?.VoucherHeading)"></div>
            <div
              class="mt-3 mb-2"
              [innerHTML]="$safeNavigationMigration(block.variables?.VoucherText)"
            ></div>
            <a
              *ngIf="block.variables?.VoucherCtaText"
              class="btn btn-warning"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.VoucherLink))"
              target="_blank"
              [innerHTML]="$safeNavigationMigration(block.variables?.VoucherCtaText)"
            >
            </a>
          </div>
        </div>
        <div class="mt-2" [innerHTML]="$safeNavigationMigration(block.variables?.VoucherParagraph)"></div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
